export default function Header({ Icon, title, description, rightCom }) {
	return (
		<div className="flex items-center justify-between bg-background/80 backdrop-blur-sm sticky top-0 z-50 p-4">
			<div className="flex items-center gap-x-3">
				<div className="flex items-center justify-center rounded-lg p-3 bg-primary/10">
					<Icon
						className="text-primary"
						size={22}
					/>
				</div>
				<div className="flex flex-col">
					<p className="text-xl font-semibold">{title}</p>
					{description && <p className="text-sm text-muted-foreground">{description}</p>}
				</div>
			</div>
			{rightCom}
		</div>
	);
}
